/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from "vue";
import Router from "vue-router";

// Routes
import paths from "./paths";

function route(path, view, name, meta) {
  return {
    name: name || view,
    path,
    meta,
    component: (resolve) => {
      import(`@/views/${view}.vue`).then((mode) => resolve(mode.default));
    },
  };
}

Vue.use(Router);

// Create a new router
const router = new Router({
  mode: "history",
  routes: paths
    .map((path) => route(path.path, path.view, path.name, path.meta))
    .concat([{ path: "*", redirect: "/dashboard" }]),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (
    to.name == "Top Funds" ||
    to.name == "View Fund" ||
    to.name == "Widget Rankings" ||
    to.name == "Login"
  ) {
    next();
    return;
  }
  if (to.meta.layout == "view-auth") {
    if (localStorage.getItem("auth-token") !== null && to.name !== "Logout") {
      if (localStorage.getItem("trader-mode") === "true") {
        next("/trader/dashboard");
      } else {
        next("/dashboard");
      }
    } else {
      next();
    }
  } else if (localStorage.getItem("auth-token") !== null) {
    next();
  } else {
    next("/login");
  }
});

export default router;
